let isRefreshing = false;
let pendingRequestResolvers = [];

export function getIsRefreshing() {
  return isRefreshing;
}

export function setIsRefreshing(value) {
  isRefreshing = value;
}

export function enqueueRequestResolver(resolver) {
  pendingRequestResolvers.push(resolver);
}

export function resolveQueuedRequests() {
  const resolvers = pendingRequestResolvers;
  pendingRequestResolvers = [];
  resolvers.forEach((resolve) => {
    try {
      resolve();
    } catch (e) {
      // ignore
    }
  });
}

export function rejectQueuedRequests(err) {
  const resolvers = pendingRequestResolvers;
  pendingRequestResolvers = [];
  resolvers.forEach((resolve) => {
    try {
      resolve(Promise.reject(err));
    } catch (e) {
      // ignore
    }
  });
}


